/** Central query-key factory for portal server state. */
export const queryKeys = {
  session: {
    all: ["session"] as const,
    profile: () => ["session", "profile"] as const,
    maintenance: () => ["session", "maintenance"] as const,
  },
  badges: {
    all: ["badges"] as const,
    pendingRequests: () => ["badges", "pendingRequests"] as const,
    collaborationSidebar: () => ["badges", "collaborationSidebar"] as const,
    wallet: () => ["badges", "wallet"] as const,
    /** Shared company↔corridor memberships (sidebar count + My Cluster + Explore). */
    myEcosystemHeadLinks: () => ["badges", "myEcosystemHeadLinks"] as const,
  },
  shortlist: {
    all: ["shortlist"] as const,
    companies: () => ["shortlist", "companies"] as const,
    ecosystemHeads: () => ["shortlist", "ecosystemHeads"] as const,
    experts: () => ["shortlist", "experts"] as const,
  },
  discover: {
    all: ["discover"] as const,
    companies: (params: Record<string, unknown>) => ["discover", "companies", params] as const,
    promoSlides: () => ["discover", "promoSlides"] as const,
    /** Shared guest+auth network composition hero (all explore tabs). */
    networkStats: () => ["discover", "networkStats"] as const,
    publicCompany: (companyId: string) => ["discover", "publicCompany", companyId] as const,
    publicExpoCompany: (expoSlug: string, companyId: string) =>
      ["discover", "publicExpoCompany", expoSlug, companyId] as const,
  },
  explore: {
    all: ["explore"] as const,
    experts: (params: Record<string, unknown>) => ["explore", "experts", params] as const,
    corridors: (params: Record<string, unknown>) => ["explore", "corridors", params] as const,
    expos: (params: Record<string, unknown>) => ["explore", "expos", params] as const,
    guestExperts: (params: Record<string, unknown>) => ["explore", "guestExperts", params] as const,
    guestCorridors: (params: Record<string, unknown>) =>
      ["explore", "guestCorridors", params] as const,
    ecosystems: () => ["explore", "ecosystems"] as const,
    ecosystem: (id: string) => ["explore", "ecosystem", id] as const,
  },
  admin: {
    all: ["admin"] as const,
    companies: (params: Record<string, unknown>) => ["admin", "companies", params] as const,
    users: (params: Record<string, unknown>) => ["admin", "users", params] as const,
    promoPop: () => ["admin", "promoPop"] as const,
    corridorPopup: (headUserId: string) => ["admin", "corridorPopup", headUserId] as const,
    collaborations: (params: Record<string, unknown>) =>
      ["admin", "collaborations", params] as const,
    overview: () => ["admin", "overview"] as const,
  },
  portal: {
    all: ["portal"] as const,
    list: (scope: string, params: Record<string, unknown>) =>
      ["portal", scope, "list", params] as const,
    detail: (scope: string, id: string) => ["portal", scope, "detail", id] as const,
  },
} as const;
